import { gql } from "@apollo/client";

export const GetSwConfigReferenceData = gql`
  query GetSwConfigReferenceData($token: String!) {
    GetSwConfigReferenceData(token: $token) {
      id
      key
      num
      list
    }
  }
`;

export const GetSwConfigReferenceDataByKey = gql`
  query GetSwConfigReferenceDataByKey($token: String!, $config_key: String!) {
    GetSwConfigReferenceDataByKey(token: $token, config_key: $config_key) {
      id
      key
      num
      list
      
    }
  }
`;
